import {NewSmallUserModel, NewUserModel, SkillLevelEnum} from "@/app/api/user";
import {CourtBigModel} from "@/app/api/courts";
import UserSmallData from "@/app/features/find_players/pages/detail_player_page/components/user_small_data/widget";

export enum TimeRangeEnum {
  MORNING = 'MORNING',
  MIDDAY = 'MIDDAY',
  EVENING = 'EVENING',
}

export const timeRangeValues: TimeRangeEnum[] = Object.values(TimeRangeEnum) as TimeRangeEnum[];

export enum OpenMatchStatusEnum {
  NOT_STARTED = 'NOT_STARTED',
  STARTED = 'STARTED',
  CANCELED = 'CANCELED',
  ARCHIVED = 'ARCHIVED',
}

export const openMatchStatusValues: OpenMatchStatusEnum[] = Object.values(OpenMatchStatusEnum) as OpenMatchStatusEnum[];

export enum SkillLevelOpenMatchEnum {
  BEGINNER = 'BEGINNER',
  INTERMEDIATE = 'INTERMEDIATE',
  ADVANCED = 'ADVANCED',
}

export interface OpenMatchModel {
  ownerId?: number;
  userIds?: number[];
  courtId?: number;
  status?: OpenMatchStatusEnum;
  eventDate?: Date;
  timeRanges?: TimeRangeEnum;
  skillLevel?: SkillLevelOpenMatchEnum;
  commentMessage?: string;
  id?: number;
}

export interface OpenMatchModelResponse {
  id?: number;
  owner?: NewSmallUserModel;
  reviews?: number[];
  countPlayers?: number;
  users?: NewSmallUserModel[];
  court?: CourtBigModel;
  status?: OpenMatchStatusEnum;
  eventDate?: Date;
  timeRanges?: TimeRangeEnum;
  skillLevel?: SkillLevelOpenMatchEnum;
  commentMessage?: string;
}

export interface OpenMatchRequestModel {
  status?: OpenMatchStatusEnum;
  skillLevel?: SkillLevelOpenMatchEnum;
  timeRanges?: TimeRangeEnum;
  eventDate?: Date;
  filterByDistance?: boolean;
}

export interface OpenMatchUpdateStatusModel {
  matchId: number;
  newStatus: OpenMatchStatusEnum;
}

export interface OpenMatchAddUserModel {
  matchId: number;
  newUserId: number;
}

export interface OpenMatchRemoveUserModel {
  matchId: number;
  userId: number;
}

export interface OpenMatchUpdateCourtModel {
  reviews: number[];
}